import React, { useEffect, useState } from 'react';
import CompanyLocationSelector from '../../Components/CompanyLocationSelector';
import Sidebar from '../../Components/Sidebar';
import trident from '../../assets/odin-trident.png';
import './AdminPages.css';
import axios from '../../api/axiosInstance';
import { logout } from '../../auth/cookieUtils';


const UserManagement = () => {
  const [users, setUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [availableLocations, setAvailableLocations] = useState([]);
  const [newLocationId, setNewLocationId] = useState(null);
  const [locationIds, setLocationIds] = useState([]);
  const [initialLocationIds, setInitialLocationIds] = useState([]);
  const [showPassword, setShowPassword] = useState(false);


  const handleLogout = () => {
    logout();
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  const fetchUsers = () => {
    axios.get('/api/users')
      .then(res => setUsers(Array.isArray(res.data) ? res.data : []))
      .catch(err => {
        console.error('Error fetching users:', err);
        alert('Failed to load users');
      });
  };

  const openEditModal = (user) => {
    const isNew = !user.id;
    setSelectedUser(user);
    setIsModalOpen(true);

    if (!isNew) {
      const userLocationIds = Array.isArray(user.locationIds) ? user.locationIds.map(Number) : [];
      setInitialLocationIds(userLocationIds);
      setLocationIds(userLocationIds);

      axios.get('/api/locations')
        .then(res => setAvailableLocations(Array.isArray(res.data) ? res.data : []))
        .catch(err => {
          console.error('Error fetching locations:', err);
          alert('Failed to load locations');
        });
    } else {
      setInitialLocationIds([]);
      setLocationIds([]);
      setAvailableLocations([]);
    }
  };

  const closeModal = () => {
    setSelectedUser(null);
    setIsModalOpen(false);
    setAvailableLocations([]);
    setNewLocationId(null);
    setLocationIds([]);
    setInitialLocationIds([]);
    setShowPassword(false);
  };

  const handleChange = (e) => {
    setSelectedUser(prev => ({
      ...prev,
      [e.target.name]: e.target.value
    }));
  };

  const handleSave = () => {
    if (!selectedUser) return;

    const isNewUser = !selectedUser.id;
    const username = String(selectedUser.username || '').trim();
    const email = String(selectedUser.email || '').trim();
    if (!username || !email) {
      alert('Username and email are required.');
      return;
    }
    const payload = {
      username,
      email,
      globalRole: selectedUser.globalRole || 'USER',
    };

    if (isNewUser) {
      payload.password = selectedUser.password || '';
      if (!payload.password) {
        alert('Password is required for new users');
        return;
      }

      axios.post('/api/users/signup', payload)
        .then(() => {
          fetchUsers();
          closeModal();
        })
        .catch(err => {
          console.error('Error creating user:', err);
          alert('Failed to create user');
        });
    } else {
      if (selectedUser.password && selectedUser.password.trim() !== '') {
        payload.password = selectedUser.password;
      }
      
      payload.companyIds = selectedUser.companyIds || [];
      payload.locationIds = locationIds;

      axios.put(`/api/users/${selectedUser.id}`, payload)
        .then(() => {
          fetchUsers();
          closeModal();
        })
        .catch(err => {
          console.error('Error updating user:', err);
          alert('Failed to update user');
        });
    }
  };

  const addLocation = () => {
    if (newLocationId && !locationIds.includes(newLocationId)) {
      setLocationIds(prev => [...prev, newLocationId]);
      setNewLocationId(null);
    }
  };

  const removeLocation = (id) => {
    setLocationIds(prev => prev.filter(lid => Number(lid) !== Number(id)));
  };

  return (
    <div className="dashboard-page">
      <div className="dashboard-topbar">
        <div className="topbar-left">
          <img src={trident} alt="Odin Logo" className="navbar-logo" />
          <CompanyLocationSelector />
        </div>

        <div className="topbar-center">
          <div className="page-title">User Management</div>
        </div>

        <div className="topbar-right">
          <button className="logout-button" onClick={handleLogout}>Logout</button>
        </div>
      </div>

      <div className="dashboard-main">
        <Sidebar />
        <div className="dashboard-content">
          <button
            type="button"
            className="add-location-btn"
            style={{ marginBottom: '12px' }}
            onClick={() =>
              openEditModal({
                username: '',
                email: '',
                password: '',
                globalRole: 'USER',
                companyIds: [],
                locationIds: []
              })
            }
          >
            + Add User
          </button>

          <table className="odin-table">
            <thead>
              <tr>
                <th>ID</th>
                <th>Username</th>
                <th>Email</th>
                <th>Role</th>
              </tr>
            </thead>
            <tbody>
              {users.map(user => (
                <tr key={user.id} onClick={() => openEditModal(user)}>
                  <td>{user.id}</td>
                  <td>{user.username}</td>
                  <td>{user.email}</td>
                  <td>{user.globalRole}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {isModalOpen && selectedUser && (
        <div className="modal-overlay">
          <div className="modal">
            <h2>{selectedUser.id ? 'Edit User' : 'Add User'}</h2>

            <label>
              Username:
              <input
                type="text"
                name="username"
                value={selectedUser.username || ''}
                onChange={handleChange}
              />
            </label>

            <label>
              Email:
              <input
                type="email"
                name="email"
                value={selectedUser.email || ''}
                onChange={handleChange}
              />
            </label>

            <label>
  Password:
  <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
  <input
    type={showPassword ? 'text' : 'password'}
    name="password"
    value={selectedUser.password || ''}
    onChange={handleChange}
    placeholder={selectedUser.id ? '(Leave blank to keep current)' : ''}
    style={{ flex: 1 }}
  />
  <button
    type="button"
    onClick={() => setShowPassword(prev => !prev)}
    style={{
      padding: '6px 10px',
      fontSize: '12px',
      cursor: 'pointer',
      border: 'none',
      borderRadius: '4px',
      backgroundColor: '#28a745', 
      color: 'white'
    }}
  >
    {showPassword ? 'Hide' : 'Show'}
  </button>
</div>

</label>


            <label>
              Role:
              <select
                name="globalRole"
                value={selectedUser.globalRole || 'USER'}
                onChange={handleChange}
                style={{ width: '100%', padding: '8px', marginTop: '4px' }}
              >
                {['USER', 'SUPER_ADMIN', 'ADMIN', 'DATA_ENTRY', 'REGIONAL_MANAGER', 'SITE_MANAGER'].map(role => (
                  <option key={role} value={role}>{role}</option>
                ))}
              </select>
            </label>

            {/* Only show location controls when editing an existing user */}
            {selectedUser.id && (
              <>
                <label>
                  Add Location:
                  <div style={{ display: 'flex', gap: '8px', marginTop: '4px' }}>
                    <select
                      value={newLocationId || ''}
                      onChange={(e) => setNewLocationId(Number(e.target.value))}
                      style={{ flex: 1 }}
                    >
                      <option value="">-- Select Location --</option>
                      {availableLocations
                        .filter(loc => !locationIds.includes(loc.id))
                        .map(loc => (
                          <option key={loc.id} value={loc.id}>
                            {loc.name} ({loc.city || 'N/A'}, {loc.state || 'N/A'})
                          </option>
                        ))}
                    </select>
                    <button type="button" className="add-location-btn" onClick={addLocation}>Add</button>
                  </div>
                </label>

                {locationIds.length > 0 && (
                  <div style={{ marginTop: '16px' }}>
                    <strong>Assigned Locations:</strong>
                    <ul>
                      {availableLocations
                        .filter(loc => locationIds.includes(loc.id))
                        .map(loc => (
                          <li key={loc.id} style={{ marginBottom: '6px' }}>
                            {loc.name} ({loc.city || 'N/A'}, {loc.state || 'N/A'})
                            <button
                              type="button"
                              className="remove-location-btn"
                              onClick={() => removeLocation(loc.id)}
                              style={{ marginLeft: '8px', color: 'red' }}
                            >
                              ✕ Remove
                            </button>
                            {!initialLocationIds.includes(loc.id) && (
                              <span style={{ marginLeft: '6px', color: 'limegreen' }}>
                                (new)
                              </span>
                            )}
                          </li>
                        ))}
                    </ul>
                  </div>
                )}
              </>
            )}

            <div className="modal-actions">
              <button type="button" onClick={handleSave}>Save</button>
              <button type="button" onClick={closeModal}>Cancel</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default UserManagement;
